import React from 'react';
import PropTypes from 'prop-types';
import {inject} from 'mobx-react';
import {browserOnly} from 'spa/Components/EnvSplit';

import {withConfig, withI18n} from 'spa/Components/Context';

import * as querystring from 'qs';

import ProgressiveImage from 'spa/Components/ProgressiveImage';

@browserOnly
@inject(({
  store: {
    landingData,
    umDeviceIdentifier,
    utmCookie,
  },
}) => (
  {
    landingData,
    umDeviceIdentifier,
    utmCookie,
  }
))
@withConfig
@withI18n
class AppsLinks extends React.Component {
  static propTypes = {
    firstImageClassname: PropTypes.string,
    firstLinkClassname: PropTypes.string,
    landingData: PropTypes.object,
    onClickLink: PropTypes.func,
    secondImageClassname: PropTypes.string,
    secondLinkClassname: PropTypes.string,
    umDeviceIdentifier: PropTypes.string,
    utmCookie: PropTypes.object,
  }

  UNSAFE_componentWillMount() {
    const {config, i18n} = this.context;
    const {landingData, umDeviceIdentifier, utmCookie} = this.props;

    if (landingData) {
      this.downloadAppsLink = config.getValue('locale.adjust-landing-page-app-url', i18n.umRegion);
    } else {
      this.downloadAppsLink = config.getValue('locale.adjust-app-url', i18n.umRegion);
    }

    let queryObject = {
      umDeviceIdentifier,
    };

    if (utmCookie) {
      queryObject = Object.assign(utmCookie, queryObject);
    }

    this.queryInfo = `?label=${encodeURIComponent(querystring.stringify(queryObject))}`;
  }

  render() {
    const {i18n} = this.context;
    const {
      firstImageClassname,
      firstLinkClassname,
      landingData,
      onClickLink,
      secondImageClassname,
      secondLinkClassname,
      umDeviceIdentifier,
      utmCookie,
      ...rest
    } = this.props;
    const {downloadAppsLink} = this;

    return (
      <div {...rest}>
        <a
          href={`${downloadAppsLink}${this.queryInfo}`}
          target="_blank"
          rel="noopener noreferrer"
          className={firstLinkClassname}
          onClick={onClickLink}
        >
          <ProgressiveImage
            disableWebp
            lowResImg={i18n._x('https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1495118209/home-en/appstore_en.svg', 'Appstore Image URL lowres')}
            highResImg={i18n._x('https://res.cloudinary.com/huxr6hrje/image/upload/v1495118209/home-en/appstore_en.svg', 'Appstore Image URL')}
            alt={i18n._x('Urban on the App Store', 'App store image alt')}
            width="135"
            className={firstImageClassname}
          />
        </a>
        <a
          href={`${downloadAppsLink}${this.queryInfo}`}
          target="_blank"
          rel="noopener noreferrer"
          className={secondLinkClassname}
          onClick={onClickLink}
        >
          <ProgressiveImage
            lowResImg={i18n._x('https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1495117099/home-en/optimised/gplay_en.png', 'PlayStore Image URL lowres')}
            highResImg={i18n._x('https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1495117099/home-en/optimised/gplay_en.png', 'PlayStore Image URL')}
            alt={i18n._x('Urban on the Play Store', 'Google Play Store image alt')}
            width="135"
            className={secondImageClassname}
          />
        </a>
      </div>
    );
  }
}

export default AppsLinks;



// WEBPACK FOOTER //
// ./spa/Components/AppsLinks.jsx